<template>
  <div class="container">
    <p style="text-align: center">
      <span style="font-size: 24px; font-weight: 700"> 《用户使用协议》 </span>
    </p>
    <p>
      工业BI在此特别提醒用户认真阅读、充分理解本《软件许可及服务协议》（下称《协议》）---
      用户应认真阅读、充分理解本《协议》中各条款，包括免除或者限制工业BI责任的免责条款及对用户的权利限制条款。请您审慎阅读并选择接受或不接受本《协议》（未成年人应在法定监护人陪同下阅读）。除非您接受本《协议》所有条款，否则您无权下载、安装或使用本软件及其相关服务。您的下载、安装、使用、帐号获取和登录等行为将视为对本《协议》的接受，并同意接受本《协议》各项条款的约束。
      本《协议》是您（下称“用户”）与工业BI平台之间关于用户下载、安装、使用、复制工业BIAPP；注册、使用、管理工业BI帐号；以及使用工业BI公司相关服务所订立的协议。
      本《协议》描述工业BI与用户之间关于“软件”许可使用及服务相关方面的权利义务。“用户”是指通过工业BI提供的获取软件授权和帐号注册的途径获得软件产品及号码授权许可以及使用工业BI公司相关服务的个人或组织。
      本《协议》可由工业BI随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。用户可重新下载安装本软件或网站查阅最新版协议条款。在工业BI修改《协议》条款后，如果用户不接受修改后的条款，请立即停止使用工业BI提供的软件和服务，用户继续使用工业BI提供的软件和服务将被视为已接受了修改后的协议。
      除本《协议》有明确规定外，本《协议》并未对利用本“软件”使用的工业BI或合作单位的其他服务规定相关的服务条款。对于这些服务，一般有单独的服务条款加以规范，用户须在使用有关服务时另行了解与确认。单独的服务条款与本协议有冲突的地方，以单独的服务条款为准。如用户使用该服务，视为对相关服务条款的接受。
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px"> 一．总则</span>
      </strong>
    </p>
    <p>
      <span>
        1．工业BI平台是工业BI提供的安装在包括但不限于移动电话、PDA等各种无线手持终端上的具有购买、咨询等功能的工业BI软件及服务。
        2．工业BI平台及服务的所有权和运营权，以及业务规则及活动的解释权均归工业BI公司所有。
        3. 若有违反本条款之规定，工业BI公司有权不经通知终止相关服务。
      </span>
    </p>
    <h2>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span style="font-family: 黑体">二、知识产权声明 </span>
        </span>
      </strong>
    </h2>
    <p>
      <span>
        1．工业BI平台由江苏大国工匠工业研究院有限公司开发。“软件”的一切版权、商标权、专利权、商业秘密等知识产权，以及与“软件”相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护，除涉及第三方授权的软件或技术外，工业BI享有上述知识产权。
        2．未经工业BI书面同意，用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何三方实施、利用、转让上述知识产权，工业BI保留追究上述未经许可行为的权利。
        3．未经工业BI书面同意，用户不得对工业BI平台进行反向工程（reverse
        engineer）、反向编译（decompile）或反汇编（disassemble），工业BI保留追究上述未经许可行为的权利。</span
      >
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>三、工业BI平台授权范围</span>
        </span>
      </strong>
    </p>
    <p>
      <span>
        1．用户可以为非商业目的在单一台手机或其他无线手持终端上安装、使用、显示、运行本“软件”。用户不得为商业运营目的安装、使用、运行本“软件”，不可以对该软件或者该软件运行过程中释放到任何无线手持终端内存中的数据及该软件运行过程中客户端与服务器端的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经授权的第三方工具/服务接入本“软件”和相关系统。
        2．用户不得未经工业BI许可，将本“软件”安装在未经工业BI明示许可的其他终端设备上。包括但不限于机顶盒、游戏机、电视机、DVD机等。
        3．保留权利：未明示授权的其他一切权利仍归工业BI所有，用户使用其他权利时须另外取得工业BI的书面同意。
        4．用户在遵守法律及本《协议》的前提下可依本《协议》使用本“软件”，用户不得实施如下行为（包括但不限于）：
        4.1删除本软件及其他副本上一切关于版权的信息；
        4.2对本软件进行反向工程，如反汇编、反编译等； 4.3修改、破坏本软件原状；
        4.4任何人进行任何危害网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐户；未经允许进入公众网络或者他人操作系统并删除、修改、增加存储信息；未经许可企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为；
        企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；
        4.5用户通过非工业BI公司开发、授权或认可的第三方兼容软件、系统登录或使用工业BI软件及服务，用户针对工业BI公司的软件和服务使用非工业BI公司开发、授权或认证的插件和外挂；
        4.6对于本“软件”相关信息等，未经工业BI书面同意，用户擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助本“软件”发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；
        4.7利用本“软件”发表、传送、传播、储存违反国家法律、危害国家安全、祖国统一、社会稳定、公序良俗的内容，或任何不当的、侮辱诽谤的、淫秽的、暴力的及任何违反国家法律法规政策的内容；
        4.8利用本“软件”发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容；
        4.9传送或散布以其他方式实现传送含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括版权或商标法（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可；
        4.10使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本“软件”获得的图像或相片的资料或信息；
        4.11通过修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营；
        4.12将本软件及工业BI提供的服务用于核设施运行、生命维持或其他会使人类及其财产处于危险之中的重大设备。用户明白本软件及工业BI提供的服务并非为以上目的而设计，如果因为软件和服务的原因导致以上操作失败而带来的人员伤亡、严重的财产损失和环境破坏，工业BI将不承担任何责任；
        4.13在未经江苏大国工匠工业研究院有限公司书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益；
        4.14其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本软件和和工业BI提供的其他服务；
        4.15用户若违反上述规定，工业BI有权采取终止、完全或部分中止、限制用户使用本软件的功能。
        5．使用本“软件”必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本《协议》。对于用户违法或违反本《协议》的使用而引起的一切责任，由用户负全部责任，一概与工业BI及合作单位无关；导致工业BI及合作单位损失的，工业BI及合作单位有权要求用户赔偿。
        6．如果用户未遵守本《协议》的任何一项条款，江苏大国工匠工业研究院有限公司有权立即终止本《协议》，并保留通过法律途径追究责任的权利。
        7．本软件为免费软件。用户可以非商业性地下载、安装、复制和散发本软件产品。如果需要进行商业性的销售、复制和散发，例如软件预装和捆绑，必须获得江苏大国工匠工业研究院有限公司的书面授权和许可。
        8．本软件为免费软件，使用本软件由用户承担风险，用户应具备本软件产品运行所需的条件，用户必须保证有权使用其运行所需操作系统。在适用法律允许的最大范围内，江苏大国工匠工业研究院有限公司在任何情况下不就用户因使用或不能使用本软件产品所发生的特殊的、意外的、直接的或间接的侵权或遭致损失承担赔偿责任。即使已事先被告知该损害发生的可能性。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>四、关于工业BI帐号</span>
        </span>
      </strong>
    </p>
    <p>
      <span>
        1．用户可以通过注册工业BI帐号使用本软件及工业BI提供的各种服务。服务包括但不限于PC端及手持终端工业BI软件等可以通过工业BI帐号登录或使用的服务，工业BI保留对公司未来服务改变和说明的权利。用户可以通过本软件客户端、登录网站、参与工业BI开展或授权开展的活动等方式向工业BI申请注册工业BI帐号。无论用户通过何种方式获得工业BI帐号，均受本协议约束。用户通过工业BI帐号使用工业BI的服务时，须同时遵守各项服务的服务条款。
        2．工业BI帐号的所有权归工业BI，用户完成申请注册手续后，获得工业BI帐号的使用权。
        3．工业BI帐号使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。如果工业BI发现使用者并非帐号初始注册人，工业BI有权在未经通知的情况下回收该帐号而无需向该帐号使用人承担法律责任，由此带来的包括并不限于用户通讯中断、用户资料清空等损失由用户自行承担。工业BI禁止用户私下有偿或无偿转让帐号，以免因帐号问题产生纠纷，用户应当自行承担因违反此要求而遭致的任何损失，同时工业BI保留追究上述行为人法律责任的权利。
        4．用户承担工业BI帐号与密码的保管责任，并就其帐号及密码项下之一切活动负全部责任。用户须重视工业BI帐号密码和公开邮箱的密码保护。用户同意如发现他人未经许可使用其帐号时立即通知工业BI。
        5．用户工业BI帐号在丢失或遗忘密码后，须遵照工业BI的申诉途径及时申诉请求找回帐号。用户应不断提供能增加帐号安全性的个人密码保护资料。用户可以凭初始注册资料及个人密码保护资料填写申诉单向工业BI申请找回帐号，工业BI的密码找回机制仅负责识别申诉单上所填资料与系统记录资料的正确性，而无法识别申诉人是否系真正帐号权使用人。对用户因被他人冒名申诉而致的任何损失，工业BI不承担任何责任，用户知晓工业BI帐号及密码保管责任在于用户，工业BI并不承诺工业BI帐号丢失或遗忘密码后用户一定能通过申诉找回帐号。
        6．用户注册工业BI帐号后如果长期不使用，工业BI有权回收帐号，以免造成资源浪费，由此带来的包括并不限于用户通信中断、用户资料丢失等损失由用户自行承担。</span
      >
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>五、使用须知</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >特别提醒用户，使用互联网必须遵守国家有关的政策和法律，如刑法、国家安全法、保密法、计算机信息系统安全保护条例、知识产权法等，保护国家利益，保护国家安全，对于违法使用互联网络而引起的一切责任，由用户负全部责任。
        1．用户不得使用本软件进行违反国家法律制度的行为。
        2．本软件同大多数移动通讯终端软件一样，易受到各种安全及使用问题的困扰，工业BI均不承担相关责任。包括但不限于：
        1）下载安装的其它软件中含有“特洛伊木马”等病毒，威胁到个人信息和数据的安全，继而威胁对本软件的使用。
        2）浏览访问某些恶意网页时，导致移动通讯终端中毒、受损。
        3）由于被下载文件提供者或网络、用户使用的软件及硬件设备等原因，导致无法正常下载。
        3．用户应加强个人资料的保护意识，以免对个人生活造成不必要的骚扰。
        4．本“软件”的替换、修改和升级：工业BI保留在任何时候通过为您提供本“软件”替换、修改、升级版本的权利以及为替换、修改或升级收取费用的权利。本“软件”为用户默认开通“升级提示”功能，视用户使用的“软件”版本差异，工业BI提供给用户自行选择是否需要开通此功能。软件新版本发布后，工业BI不保证旧版本软件的继续可用。工业BI保留因业务发展需要，单方面对软件的部分功能效果进行改变或进行限制，用户需承担此风险。
        5．工业BI敬请用户按照工业BI的指定网站或指定方式下载安装本软件产品。谨防在非指定网站下载本软件，以免移动通讯终端感染能破坏用户数据和获取用户隐私信息的恶意程序。
        6．用户同意：个人隐私信息是指那些能够对用户进行个人辨识或涉及个人通信的信息，包括下列信息：用户的姓名，身份证号，手机号码，IP地址，电子邮件地址信息。而非个人隐私信息是指用户对本软件的操作状态以及使用习惯等一些明确且客观反映在工业BI服务器端的基本记录信息和其他一切个人隐私信息范围外的普通信息。
        尊重用户个人隐私信息的私有性是工业BI的一贯制度，工业BI将会采取合理的措施保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或用户同意等原因外，工业BI未经用户同意不向除合作单位以外的第三方公开、透露用户个人隐私信息。但是用户在注册时选择或同意，或用户与工业BI及合作单位之间就用户个人隐私信息公开或使用另有约定的除外，同时用户应自行承担因此可能产生的任何风险，工业BI对此不予负责。同时为了运营和改善工业BI的技术和服务，我们将可能会自己收集使用或向第三方提供用户的非个人隐私信息，这将有助于向用户提供更好的用户体验和提高我们的服务质量。
        一般而言，工业BI基于下列原因需要使用到用户的信息资源：
        6.1执行软件验证服务； 6.2执行软件升级服务；
        6.3提高用户的使用安全性并提供客户支持；
        6.4因用户使用工业BI软件特定功能等或因用户要求工业BI或合作单位提供特定服务时，工业BI或合作单位则需要把用户的信息提供给与此相关联的第三方；
        6.5将各种非个人隐私数据用于商业目的，包括但不限于向第三方提供增值服务、广告、定位广告、营销、联合注册其它服务、促销或其它任何活动（统称为“商业活动”）；
        6.6执行工业BI的《隐私保护声明》，用户可访问工业BI网站查阅该声明；
        6.7其他有利于用户和工业BI利益的。
        7．用户必须自行配备手机等无线手持终端上网和使用电信增值业务所需的设备，自行负担个人手机等无线手持终端上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，我们建议您与您的电信增值服务提供商确认相关的费用问题。
        8．您可使用本软件及服务发表属于您原创或您有权发表的观点看法、数据、文字、信息、用户名、图片、照片、个人信息、音频、视频文件、链接等。您必须保证，您拥有你所上传内容的著作权或已获得合法授权，您使用本软件及服务的任何行为未侵犯任何第三方之合法权益。
        9．您了解并且同意只要您使用本软件及服务，您将遵守本条款中的权利义务。您对所有在您的注册名下发生的一切行为负责；
        10．您了解并且同意工业BI公司不能为用户行为负责。使用本软件及服务产生的所有风险由您个人承担，工业BI公司不对本软件及服务的适用性、合法性、安全性、无毒性做任何形式的保证。如果您发现本软件及服务中存在任何违法违规行为，有义务及时向工业BI公司举报。
        11．用户不得利用本软件及服务进行故意制作、传播计算机病毒等破坏性程序，不得针对本服务、与本软件及服务连接的服务器或网络制造干扰、混乱，或违反连接本软件及服务的网络的任何要求、程序、政策或规则，否则工业BI将保留追究其法律责任的权利并有权将其提交给相关部门处理。
        12．用户不得利用本软件及服务传播、复制、发送、上传和发布任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽色情性等内容的信息。
        13．用户依本协议条款所取得的服务权利不可转让。
        14．如用户违反国家法律法规或本协议条款，本公司和合作公司将有权停止向用户提供服务而不需承担任何责任。如导致工业BI或其合作公司遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向本公司或合作公司赔偿相应的损失，用户并需对其违反服务条款所产生的一切后果负全部法律责任。工业BI有权认定和删除用户所发表的任何不符合国家法律、法规和政策、本服务条款的任何文章、资料、图片、图表等内容，且不需要对用户另行通知。
        15．工业BI保留在任何时候因为任何原因拒绝向任何人提供服务的权利。
        16．用户须遵守包括但不限于以下严禁事宜： 16.1
        利用本软件及服务传播反对宪法所确定的基本原则的内容； 16.2
        利用本软件及服务传播危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的内容；
        16.3利用本软件及服务传播损害国家荣誉和利益的内容；
        16.4利用本软件及服务传播煽动民族仇恨、民族歧视，破坏民族团结的内容；
        16.5利用本软件及服务传播破坏国家宗教政策，宣扬邪教和封建迷信的内容；
        16.6利用本软件及服务散布谣言，扰乱社会秩序，破坏社会稳定的内容；
        16.7利用本软件及服务散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的内容；
        16.8利用本软件及服务传播侮辱或者诽谤他人，侵害他人合法权益的内容；
        16.9利用本软件及服务传播含有法律、行政法规禁止的其他内容；
        16.10上传任何病毒，木马，或者蠕虫等危害网络健康的内容；
        16.11制作、发布、传播用于窃取工业BI帐号及他人专属信息、财产、保密信息的软件；
        16.12在未经工业BI书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益；
        16.13其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本软件和和工业BI提供的其他服务；
        17．工业BI有权在服务中或经过服务投放各种广告和宣传信息，该广告可能以系统消息或弹出窗口等形式出现。
        18．如因用户不遵守本条上述任意一款或者几款的规定，工业BI有权在不事先通知用户的情况下将相应的内容删除或采取终止、完全或部分中止、限制用户帐号的使用功能或停止用户使用本软件或服务；如造成工业BI损失的，工业BI有权要求用户给予相应的赔偿，包括但不限于工业BI因此被国家机关予以行政处罚，或者被第三方通过诉讼或其他的方式索赔，赔偿范围包括但不限于罚款、赔偿金以及工业BI支付的相应的诉讼费、律师费。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>六、服务风险及免责声明</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >1．利用的许可 1.1
        许可利用您的移动通讯终端：为了得到本“软件”所提供的利益，用户在此许可工业BI利用用户移动通讯终端的处理器和带宽，用作容许其它工业BI平台使用者与用户通讯联络的有限目的。
        1.2
        保护用户的移动通讯终端资源：用户认可工业BI平台将会尽其商业上的合理努力以保护用户的移动通讯终端资源及移动通讯终端通讯的隐私性和完整性，但是，
        用户承认和同意工业BI不能就此事提供任何保证。
        2．工业BI特别提请用户注意，工业BI为了保障公司业务发展和调整的自主权，工业BI拥有随时修改或中断服务而不需通知用户的权利，工业BI行使修改或中断服务的权利不需对用户或任何第三方负责。用户必须在同意本条款的前提下，工业BI才开始对用户提供服务。
        3．用户违反本《协议》或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿工业BI与合作公司、关联公司，并使之免受损害。
        3．用户因第三方如通讯线路故障、技术问题、网络、移动通讯终端故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，工业BI及合作单位不承担责任。
        4．因技术故障等不可抗事件影响到服务的正常运行的，工业BI及合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，工业BI及合作单位不承担责任。
        5．本“软件”同大多数互联网软件一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的移动通讯终端信息和数据的安全，继而影响本“软件”的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
        6．非经工业BI或工业BI授权开发并正式发布的其它任何由本“软件”衍生的软件均属非法，下载、安装、使用此类软件，将可能导致不可预知的风险，由此产生的一切法律责任与纠纷一概与工业BI无关。
        7．用户须明白，使用本软件产品涉及到Internet服务，可能会受到各个环节不稳定因素的影响。因此服务存在因不可抗力、移动通讯终端病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。用户须承担以上风险，本公司不作担保。对因此导致用户不能发送和接受阅读信息、或接发错信息，公司不承担任何责任。
        8．用户须明白，在使用本软件产品存在有来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）的匿名或冒名的信息的风险，用户须承担以上风险，本公司和合作公司对服务不作任何类型的担保，不论是明确的或隐含的，包括所有有关信息真实性、适商性、适于某一特定用途、所有权和非侵权性的默示担保和条件，对因此导致任何因用户不正当或非法使用服务产生的直接、间接、偶然、特殊及后续的损害，不承担任何责任。
        9．因用户使用本软件或要求工业BI提供特定服务时，本软件可能会调用第三方系统支持用户的使用或访问，使用或访问的结果由该第三方提供，工业BI不保证通过第三方系统支持实现的结果的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与工业BI无关，工业BI不承担任何责任。
        10．
        本公司定义的信息内容包括：文字、软件、声音、相片、录像、图表；在广告中全部内容；本公司为用户提供的商业信息，所有这些内容受版权、商标权、和其它知识产权和所有权法律的保护。所以，用户只能在本公司和广告商授权下才能使用这些内容，而不能擅自复制、修改、编撰这些内容、或创造与内容有关的衍生产品。
        11.
        用户在使用本软件及服务时，须自行承担如下包括但不限于来自工业BI不可掌控的风险内容：
        11.1
        由于无线网络宽带不稳定等原因引起的名片、短信、通话记录、浏览器书签等个人信息丢失、泄漏等风险。
        11.2
        用户必须选择与所安装手机相匹配的工业BI平台版本，否则，由于软件与手机型号不相匹配所导致的任何软件问题、手机问题或损害，均由用户自行承担。
        11.3 用户手机隐私信息在使用本软件及服务时可能产生的信息安全风险。 11.4
        用户在使用本软件访问第三方网站时遇到内容质量及安全问题等，均由用户自行承担。
        12. 工业BI在此特别提醒： 12.1
        使用本“软件”必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本《协议》。对于用户违法或违反本《协议》的使用而引起的一切责任，由用户负全部责任，一概与工业BI及合作单位无关；导致工业BI及合作单位损失的，工业BI及合作单位有权要求用户赔偿，并有权保留相关记录。而且，对于用户违法或违反本《协议》以及违反了利用本软件和工业BI帐号访问的工业BI或合作单位的其他服务规定的相关服务条款，工业BI有权视用户的行为性质，在不事先通知用户的情况下，采取包括但不限于中断使用许可、停止提供服务、限制使用、回收用户工业BI帐号、法律追究等措施。对利用工业BI帐号进行违法活动、骚扰、欺骗其他用户等行为，工业BI有权回收其帐号。由此带来的包括并不限于用户通信中断、用户资料丢失等损失由用户自行承担。
        12.2
        非经工业BI或工业BI授权开发并正式发布的其它任何由本“软件”衍生的软件均属非法，下载、安装、使用此类软件，将可能导致不可预知的风险，由此产生的一切法律责任与纠纷一概与工业BI无关。用户不得轻易下载、安装、使用此类软件，否则，工业BI有权在不事先通知用户的情况下单方面终止用户工业BI帐号的使用资格。
        12.3
        用户只能通过工业BI提供的本“软件”及其他合法通道登录使用工业BI。用户不得通过其他未经工业BI授权开发的包括但不限于非法兼容型软件、程序或者其他非工业BI明示许可的方式，登录使用工业BI帐号，否则，工业BI有权在不事先通知用户的情况下单方面终止用户的工业BI帐号的使用资格。
        13.
        用户所有信息均自行提供，需要确保录入或者上传信息及时、准确，应用将完全根据用户提供的信息做出反馈，如果用户提供的信息有误，造成的任何后果自行承担。
        14.
        如用户存在任何信息在应用系统中无法体现时，默认该用户不符合软件服务要求，软件拒绝提供服务，所有推荐信息均不得做以任何意义上的参考。如擅自获得信息并作为参考，任何后果用户自行承担。
        15.
        用户提供的健康信息及相关的一切记录，如果工业BI网认为其内容包含任何不基于事实、虚构、编造及无亲身经历的言论，带有威胁、淫秽、漫骂、非法及带有人身攻击之言论，含有色情、暴力、恐怖内容、含有违背伦理道德内容，涉及违法犯罪的内容，以及其他工业BI认为不恰当的情况，工业BI有权进行编辑、删除、直至取消该账户资格，并保留进行法律追究的权利。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>七、服务及协议条款的变更</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >工业BI有权在必要时修改本协议条款，协议条款一旦发生变动，将会在相关页面上公布修改后的协议条款。如果不同意所改动的内容，用户应主动取消此项服务。如果用户继续使用服务，则视为接受协议条款的变动。
        工业BI和合作公司有权按需要修改或变更所提供的收费服务、收费标准、收费方式、服务费、及服务条款。工业BI在提供服务时，可能现在或日后对部分服务的用户开始收取一定的费用如用户拒绝支付该等费用，则不能在收费开始后继续使用相关的服务。工业BI和合作公司将尽最大努力通过电邮或其他有效方式通知用户有关的修改或变更。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>八、争议管辖及适用法律</span>
        </span>
      </strong>
    </p>
    <p>
      <span
        >本协议条款之效力和解释均适用中华人民共和国之法律。如协议条款之任何一部分与中华人民共和国法律相抵触，则该部分条款应按法律规定重新解释，部分条款之无效或重新解释不影响其它条款之法律效力。用户和工业BI一致同意凡因本服务所产生的纠纷双方应协商解决，协商不成任何一方可提交工业BI公司所在地苏州市有管辖权的法院诉讼裁决。
        工业BI版权所有，保留一切解释权利。
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "ros-use-agreement",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.container {
  margin: 20px auto;
  text-align: initial;
  max-width: 1200px;
  font-family: 宋体;
  font-size: 14px;
  height: auto;
}
p {
  line-height: 35px;
}
@media (max-width: 768px) {
  .container {
    font-size: 12px !important;
    color: #555;
    padding: 0 5%;
    width: 90%;
    background: rgb(14, 80, 177);
    margin-top: 0;
    .container {
      background-color: #fff;
      border-radius: 10px;
      padding-top: 20px;
      margin-top: 20px;
    }
    .wrapper {
      .container {
        background: none;
      }
    }
  }
}
</style>
